import { DEFAULT_ICE_SERVERS } from './signaling.js';
function isIceServer(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const record = value;
    const urls = record['urls'];
    const urlsOk = typeof urls === 'string' ||
        (Array.isArray(urls) && urls.every((u) => typeof u === 'string'));
    if (!urlsOk)
        return false;
    // username y credential son opcionales pero, si están, tienen que ser strings.
    if ('username' in record && typeof record['username'] !== 'string')
        return false;
    if ('credential' in record && typeof record['credential'] !== 'string')
        return false;
    return true;
}
/**
 * Interpreta el contenido de un archivo de config ICE. Ante cualquier duda cae al
 * STUN por defecto en vez de romper la conexión: sin ICE válido no habría llamada.
 */
export function parseIceConfig(value) {
    if (typeof value !== 'object' || value === null)
        return [...DEFAULT_ICE_SERVERS];
    const servers = value['iceServers'];
    if (!Array.isArray(servers))
        return [...DEFAULT_ICE_SERVERS];
    const valid = servers.filter(isIceServer);
    return valid.length > 0 ? valid : [...DEFAULT_ICE_SERVERS];
}
//# sourceMappingURL=ice.js.map